import { FC } from 'react';

interface OwnProps {
  errors: string[];
  warnings: string[];
}

const ErrorsList: FC<OwnProps> = ({ errors, warnings }) => {
  const items = errors.concat(warnings);

  return items.length === 0 ? null : items.length === 1 ? (
    <span>{items[0]}</span>
  ) : (
    <ul style={{ paddingInlineStart: '1rem', marginBottom: 0 }}>
      {items.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  );
};

export default ErrorsList;
